/*
 * @Description:
 * @Author: ma.cq
 * @Date: 2021-04-25 11:34:21
 * @LastEditors: ma.cq
 * @LastEditTime: 2021-05-10 15:46:01
 */
export const columnMap = {
  0: [
    {
      label: '统计时间段',
      prop: 'name'
    },
    {
      label: '今日访客数',
      prop: 'num'
    },
    {
      label: '昨日访客数',
      prop: 'beforeNum'
    }
  ],
  1: [
    {
      label: '统计时间段',
      prop: 'name'
    },
    {
      label: '今日浏览量',
      prop: 'num'
    },
    {
      label: '昨日浏览量',
      prop: 'beforeNum'
    }
  ],
  2: [
    {
      label: '统计时间段',
      prop: 'name'
    },
    {
      label: '今日跳失率',
      prop: 'num'
    },
    {
      label: '昨日跳失率',
      prop: 'beforeNum'
    }
  ],
  3: [
    {
      label: '统计时间段',
      prop: 'name'
    },
    {
      label: '经营组织',
      prop: 'orgName'
    },
    {
      label: '今日支付买家数',
      prop: 'num'
    },
    {
      label: '昨日支付买家数',
      prop: 'beforeNum'
    }
  ],
  4: [
    {
      label: '统计时间段',
      prop: 'name'
    },
    {
      label: '经营组织',
      prop: 'orgName'
    },
    {
      label: '商品名称',
      prop: 'itemName'
    },
    {
      label: '到厂数量',
      prop: 'num'
    },
    {
      label: '出厂数量',
      prop: 'beforeNum'
    }
  ]
}

export const cardDataList = [
  {
    title: '访客数',
    iconName: 'user',
    intro: `统计范围：指独立访客，将每个登陆电商的用户视为一位访客。\n
    去重逻辑：统计时间内相同用户的访问只被计算1次`
  },
  {
    title: '浏览量',
    iconName: 'line',
    intro: '统计范围：指PV即页面浏览量或者点击量,用户每次对网站的访问均被记录1次。用户对同一页面的多次访问，浏览量值累计'
  },
  {
    title: '跳失率',
    iconName: 'line',
    intro: '统计范围：统计指定时间段内，访客中没有发生点击行为（活动专栏、搜索、个人账号、我的认证、搜索、类目、右侧导航栏、立刻购买、详情）的人数/访客数，即跳失率=1-点击人数/访客数'
  },
  {
    title: '支付买家数',
    iconName: 'user',
    intro: `统计范围：统计指定时间内，完成支付的用户\n
      去重逻辑：在统计时间段内同一个客户多次支付，只被记做一次`
  },
  {
    title: '排队车辆',
    iconName: 'queue',
    intro: `统计范围：统计指定时间段内，进厂和出厂的车辆`
  }
]
